var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #a98e55;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300,
    cy: 300,
    r: 266.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.26,280.58c23.32,45.77,60.56,82.97,106.37,106.25l35.52-35.59c4.45-4.45,10.8-5.72,16.39-3.95,18.03,5.96,37.5,9.2,57.59,9.2,8.95,0,16.14,7.19,16.14,16.14v56.49c0,8.95-7.19,16.14-16.14,16.14-151.56,0-274.37-122.81-274.37-274.37,0-8.91,7.23-16.14,16.14-16.14h56.49c8.95,0,16.14,7.19,16.14,16.14,0,20.09,3.24,39.55,9.2,57.62,1.78,5.55.51,11.94-3.95,16.4l-35.51,35.68h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcons);
export default __webpack_public_path__ + "static/media/contact_icons.c373fb3ba25141a4a87411da3c014b20.svg";
export { ForwardRef as ReactComponent };